import { GroupId } from '@sr/types';
import GroupControls from './GroupControls';
import MessageDetails from './MessageDetails';
import NoMessages from './NoMessages';
import { useMessagesIdsForGroup } from 'store/selectors/messages';
import { Box } from 'v1/ui';

export default function GroupContents({ groupId }: { groupId: GroupId }) {
  const messageIds = useMessagesIdsForGroup(groupId);
  const numMessages = messageIds.length;

  if (numMessages === 0) {
    return <NoMessages groupId={groupId} />;
  }

  return (
    <Box sx={{ p: 4, pt: 0 }}>
      {numMessages > 1 && (
        <GroupControls groupId={groupId} numMessages={numMessages} />
      )}
      <MessageDetails groupId={groupId} />
    </Box>
  );
}
